module.exports = __webpack_public_path__ + "img/zip.371865d0.svg";